import { CommonModule } from "@angular/common";
import { Component, input } from "@angular/core";
import { BaseConfig } from "../common/config/config.adapter";

@Component({
    selector: "app-divider",
    styleUrls: ["./divider.component.scss"],
    standalone: true,
    template: `
        <div class="flex items-center">
            <div
                [attr.data-type]="type()"
                class="w-full h-px bg-gray-200"
            ></div>
            @if (label()) {
                <div
                    class="px-4 text-gray-500 font-medium text-sm theme-text min-w-max"
                >
                    {{ label() }}
                </div>
            }
            <div
                [attr.data-type]="type()"
                class="w-full h-px bg-gray-200"
            ></div>
        </div>
    `,
    imports: [CommonModule],
})
export class Divider extends BaseConfig {
    label = input<string>();
    type = input<"solid" | "dashed">();
}
